import { camelToSentence } from '../../../../utils';
import config from '../../../../config';

const { onPremise } = config;

// const NON_SPARE_ASSET_STATES = [
//   { type: 'string', enum: ['installed'], title: 'Installed' },
//   { type: 'string', enum: ['repair'], title: 'On repair' },
//   { type: 'string', enum: ['retired'], title: 'Retired' },
// ];
// const ASSET_STATES = [
//   ...NON_SPARE_ASSET_STATES,
//   { type: 'string', enum: ['spare'], title: 'Spare part' },
// ];
// const REPLACEABLE_COMPONENT_TYPES = ['component']; // include group?

const buildMainDependencies = (
  component,
  commonNonSiteProperties,
  areaStateSets,
  variables,
  sources
  // components,
) => {
  const statusSignalOnPremDescription = `Signals on which a defined state set has been added. Signal-based states can be displayed in the component panel${onPremise ? '' : ' and in the spatial viewer'}.`;
  const stateSignalOnPremDescription = `User-defined state displayed in the component panel${onPremise ? '' : ' and in the spatial viewer'}.`;

  const statusSignalProperty = {
    ...(variables.length > 0
      ? {
          statefulVariables: {
            type: 'array',
            title: 'Stateful signals',
            placeholder: 'Select stateful signals',
            parseDescription: true,
            description: JSON.stringify([statusSignalOnPremDescription]),
            action: 'info',
            isMulti: true,
            selectOptions: variables.map((variable) => ({
              value: variable.id,
              label: `[${variable.itemDesignation || ' '}] ${variable.name}`,
            })),
          },
        }
      : {}),
  };

  const sourceProperty = {
    source: {
      type: ['string', 'null'],
      title: 'Data Source',
      default: null,
      description:
        'Linked data source for iot events. Data source is typically attached to the site component.',
      action: 'info',
      selectOptions: [
        {
          value: null,
          label: 'None',
        },
        ...sources.map((source) => ({
          value: source.id,
          label: source.name,
        })),
      ],
    },
  };

  return {
    type: {
      oneOf: [
        {
          properties: {
            type: { enum: ['virtual'] },
            ...(component.type === 'site' ? {} : commonNonSiteProperties),
            ...(areaStateSets.length > 0
              ? {
                  stateset_id: {
                    type: 'string',
                    title: 'State',
                    placeholder: 'Select a state',
                    description: stateSignalOnPremDescription,
                    action: 'info',
                    selectOptions: areaStateSets.map((stateset) => ({
                      value: stateset.id,
                      label: stateset.name,
                    })),
                  },
                }
              : {}),
          },
        },
        {
          properties: {
            // awaiting decision on whether group shoud be included here (have asset state, source, etc)
            type: { enum: ['component', 'group'] },
            ...(component.type === 'site' ? {} : commonNonSiteProperties),
            // ...(component.type === 'component'
            //   ? {
            //       assetState: {
            //         type: 'string',
            //         title: 'Equipment state',
            //         default: 'installed',
            //         oneOf: ASSET_STATES,
            //       },
            //     }
            //   : {}),
            ...sourceProperty,
            ...statusSignalProperty,
          },
          // dependencies: {
          //   assetState: {
          //     oneOf: [
          //       {
          //         properties: {
          //           assetState: { enum: [NON_SPARE_ASSET_STATES.map((stateOpt) => ...stateOpt.enum)] },
          //         },
          //       },
          //       {
          //         properties: {
          //           assetState: { enum: ['spare'] },

          //           spareTo: {
          //             type: 'array',
          //             title: 'Spare part to',
          //             placeholder: 'Select component(s) this can replace',
          //             default: [],
          //             isMulti: true,
          //             uniqueItems: true,
          //             description: 'Spare part to description...',
          //             action: 'info',
          //             selectOptions: components.map((comp) => ({
          //               value: comp.id,
          //               label: `[ ${comp.itemDesignation} ] ${comp.name}`,
          //             })),
          //           },
          //         },
          //       },
          //     ],
          //   },
          // },
        },
        {
          properties: {
            type: { enum: ['site'] },
            ...sourceProperty,
            ...statusSignalProperty,
          },
        },
      ],
    },
  };
};

const getMainSchema = (
  component = {},
  sortedCompsNotSelfOrDescendant = [],
  stateSets = [],
  variables = [],
  sources = [],
  sourceTypes = []
) => {
  const areaStateSets = stateSets.filter((stateset) => !!stateset.isVirtualStateSet);
  const filteredSources = sources.filter((s) => sourceTypes.map((st) => st.name).includes(s.type));

  const commonNonSiteProperties = {
    parent: {
      type: 'string',
      label: 'Parent',
      components: sortedCompsNotSelfOrDescendant,
      styles: {
        control: { maxWidth: '35rem' },
      },
    },
  };

  const schema = {
    type: 'object',
    required: ['name', 'type', 'itemDesignation'],
    properties: {
      name: {
        type: 'string',
        title: 'Name',
        default: '',
      },
      itemDesignation: {
        type: 'string',
        title: 'Reference designation*',
        parseDescription: true,
        description: JSON.stringify([
          'Unique component identifier used in Hitachi Energy.',
          'Changing this may lead to unwanted consequences.',
        ]),
        action: 'info',
      },
      customId: {
        type: 'string',
        title: 'Custom ID',
        // Update this to include view in comp panel after implementation
        description: 'Alternative component identifier that can be defined by site owners.',
        action: 'info',
      },
    },

    dependencies: buildMainDependencies(
      component,
      commonNonSiteProperties,
      areaStateSets,
      variables,
      filteredSources
      // sortedReplaceableCompsNotSelf
    ),
  };

  if (component.type === 'site') {
    schema.properties.type = {
      type: 'string',
      title: 'Type*',
      default: 'site',
      description:
        'The "site" type designates the root component, from which all other components are derived.',
      action: 'info',
      selectOptions: [{ value: 'site', label: 'Site' }],
    };
  } else {
    schema.properties.type = {
      type: 'string',
      title: 'Type*',
      default: 'component',
      parseDescription: true,
      description: JSON.stringify([
        'Equipment: Electrical / mechanical assets (replaceable)',
        'Group: Logical collection of equipment',
        'Virtual: Spatial representation, e.g. safety zone',
      ]),
      action: 'info',
      selectOptions: [
        { value: 'component', label: 'Equipment' },
        { value: 'group', label: 'Group' },
        { value: 'virtual', label: 'Virtual' },
      ],
    };
    schema.required.push('parent');
  }
  return schema;
};

const VALID_ORDERED_COMPONENT_MAIN_KEYS = [
  'type',
  'name',
  'itemDesignation',
  'parent',
  'customId',
  'stateset_id',
  // 'assetState',
  // 'spareTo',
  'statefulVariables',
  'source', // component.source_id re-keyed (duplicate key error with event source keys)
];

const mainUiSchema = {
  'ui:order': VALID_ORDERED_COMPONENT_MAIN_KEYS,
  type: {
    'ui:field': 'inputWithTooltip',
  },
  itemDesignation: {
    'ui:field': 'inputWithTooltip',
  },
  parent: {
    'ui:field': 'componentPickerField',
  },
  customId: {
    'ui:field': 'inputWithTooltip',
  },
  source: {
    'ui:field': 'inputWithTooltip',
  },
  stateset_id: {
    'ui:field': 'inputWithTooltip',
  },
  // spareTo: {
  //   'ui:classNames': 'multi-select-array',
  //   'ui:field': 'inputWithTooltip',
  // },
  statefulVariables: {
    'ui:classNames': 'multi-select-array',
    'ui:field': 'inputWithTooltip',
  },
};

const getModelSchema = (models = [], thumbnails = []) => {
  if (models.length === 0) {
    return null;
  }
  return {
    type: 'object',
    title: '',
    required: ['modelId', 'customName'],
    properties: {
      modelId: {
        type: 'string',
        title: 'Model',
        placeholder: 'Select a model',
        oneOf: models.map((model) => ({
          enum: [model.id],
          title: model.name,
        })),
      },
      customName: {
        type: 'string',
        title: 'Display name',
      },
    },
    dependencies: {
      modelId: {
        oneOf: models.map((m) => {
          const hasCustomThumbnail =
            m.versions?.[0]?.thumbnail?.split(':')[1]?.split('/')[0] === 'image';
          return {
            properties: {
              modelId: {
                enum: [m.id],
              },
              image: {
                type: 'string',
                title: ' ',
                thumbnail:
                  (hasCustomThumbnail && m.versions?.[0]?.thumbnail) ||
                  thumbnails[`${m.id}/${m.versions?.[0]?.id}`],
              },
            },
          };
        }),
      },
    },
  };
};

const modelUiSchema = {
  image: {
    'ui:field': 'modelArrayField',
    'ui:classNames': 'thumbnail-field',
  },
};

const getEventSourcesSchema = (filteredEventSources = [], sourceTypes = []) => ({
  title: '',
  type: 'object',

  required: ['source_id'],
  properties: {
    name: {
      type: 'string',
      title: 'Name',
    },
    description: {
      type: 'string',
      title: 'Description',
    },
    source_id: {
      type: 'string',
      title: 'Event Source',
      oneOf: filteredEventSources.map((source) => ({
        enum: [source.id],
        title: source.name,
      })),
    },
  },

  dependencies: {
    source_id: {
      oneOf: filteredEventSources.map((source) => {
        const sourceType = sourceTypes.find((st) => st.name === source.type);

        return {
          properties: {
            source_id: { enum: [source.id] },

            options: {
              type: 'object',
              title: '',
              required: sourceType.schemas.event.required,
              properties: {
                ...Object.entries(sourceType.schemas.event.properties).reduce((acc, [k, v]) => {
                  acc[k] = { ...v, title: camelToSentence(k) };
                  return acc;
                }, {}),
              },
            },
          },
        };
      }),
    },
  },
});

const VALID_COMPONENT_KEYS = [
  ...VALID_ORDERED_COMPONENT_MAIN_KEYS,
  'models',
  'options',
  'sourceConfig',
  'eventSources',
];

export {
  getMainSchema,
  mainUiSchema,
  getModelSchema,
  modelUiSchema,
  getEventSourcesSchema,
  VALID_COMPONENT_KEYS,
};
